import gql from "graphql-tag";

export const setUserOnboardingCompleted = gql`
  mutation SetUserOnboardingCompleted($input: SetUserOnboardingCompletedRequestInput) {
    SetUserOnboardingCompleted(input: $input) {
      success
    }
  }
`;
